type DotPatternProps = {
  /** Unique id — required because multiple instances render their own <pattern> def. */
  id: string;
  /** Dot color (any CSS color, defaults to a subtle gray). */
  color?: string;
  /** Tile size in px — controls the spacing between dots. */
  size?: number;
  /** Dot radius in px. */
  radius?: number;
  /** CSS mask used to fade the pattern (mask-image value). */
  mask?: string;
  style?: React.CSSProperties;
};

/**
 * Decorative SVG dot grid. Rendered absolutely-positioned to fill its
 * (relatively-positioned) parent. Used in the hero and feature cards.
 */
export function DotPattern({
  id,
  color = "var(--mantine-color-gray-4)",
  size = 22,
  radius = 1,
  mask,
  style,
}: DotPatternProps) {
  return (
    <svg
      aria-hidden="true"
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        color,
        maskImage: mask,
        WebkitMaskImage: mask,
        pointerEvents: "none",
        ...style,
      }}
    >
      <defs>
        <pattern id={id} x="0" y="0" width={size} height={size} patternUnits="userSpaceOnUse">
          <circle cx="1" cy="1" r={radius} fill="currentColor" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${id})`} />
    </svg>
  );
}
